export default {
  main: "0 2px 16px 8px rgba(0, 0, 0, 0.05)",
  button: "0 2px 16px 8px rgba(0, 0, 0, 0.05)",
  red: "0 4px 16px rgba(223, 100, 57, 0.15)",
  blue: "0 4px 16px rgba(12, 108, 242, 0.15)",
};
